import { FilterOptions, SubfilterOptions } from "./modals/PrimaryNavModalModels.context";
import { BodyTypeData } from "./types/PrimaryNav.types";

export const filterBodyTypes = (data: BodyTypeData[], filter: FilterOptions) =>
  data.reduce((acc: BodyTypeData[], curr) => {
    if (
      curr.displayName.toLowerCase() !== filter.body.toLowerCase() &&
      filter.body.toLowerCase() !== "all"
    )
      return acc;

    const matchingModels = [];
    for (const model of curr.models) {
      const fuelMatch = !filter.fuel || model.fuelTypes.some((type) => filter.fuel === type);
      const lifeStyleMatch = !filter.lifestyle || filter.lifestyle === model.lifestyle;
      const seatMatch = !filter.seats || model.seats.some((seats) => filter.seats === seats);

      if (fuelMatch && lifeStyleMatch && seatMatch) {
        matchingModels.push(model);
      }
    }
    if (matchingModels.length > 0) {
      acc.push({ ...curr, models: matchingModels });
    }
    return acc;
  }, []);

export const calcSubfilterOptions = (data: BodyTypeData[]): SubfilterOptions => {
  const seats = new Set<string>();
  const lifestyle = new Set<string>();
  const fuel = new Set<string>();

  for (const { models } of data) {
    for (const model of models) {
      model.seats.forEach((seat) => seats.add(seat));
      lifestyle.add(model.lifestyle);
      model.fuelTypes.forEach((fuelType) => fuel.add(fuelType));
    }
  }

  return {
    seats,
    lifestyle,
    fuel,
  };
};
